"use client"

import { usePathname, useSearchParams } from "next/navigation"

// Rebuild the Pages Router `asPath` (pathname + query string) from App Router hooks.
export function useAsPath() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const query = searchParams.toString()
  return query ? `${pathname}?${query}` : pathname
}
